module.exports = __webpack_public_path__ + "static/image1-1ddab2b5b39a235ad3634b5f2e144db7.jpg";